export type VisibilityClassPair = {
	show: string;
	hide: string;
};

function buildResponsiveVisibilityCss(
	responsiveVisibility: readonly string[] | null | undefined,
	visibilityMap: Record<string, VisibilityClassPair>,
): string | null {
	if (!responsiveVisibility || responsiveVisibility.length === 0) {
		return null;
	}

	const visibilityList = Object.entries(visibilityMap).map(
		([key, { show, hide }]) =>
			responsiveVisibility.includes(key) ? show : hide,
	);

	return visibilityList.join(" ");
}

export function toResponsiveVisibilityCss(
	responsiveVisibility: readonly string[] | null | undefined,
): string | null {
	const visibilityMap: Record<string, VisibilityClassPair> = {
		xs: { show: "block", hide: "hidden" },
		sm: { show: "sm:block", hide: "sm:hidden" },
		md: { show: "md:block", hide: "md:hidden" },
		lg: { show: "lg:block", hide: "lg:hidden" },
		xl: { show: "xl:block", hide: "xl:hidden" },
	};

	return buildResponsiveVisibilityCss(responsiveVisibility, visibilityMap);
}

export function toResponsiveFlexVisibilityCss(
	responsiveVisibility: string[] | null | undefined,
): string | null {
	const visibilityMap: Record<string, VisibilityClassPair> = {
		xs: { show: "flex", hide: "hidden" },
		sm: { show: "sm:flex", hide: "sm:hidden" },
		md: { show: "md:flex", hide: "md:hidden" },
		lg: { show: "lg:flex", hide: "lg:hidden" },
		xl: { show: "xl:flex", hide: "xl:hidden" },
	};

	return buildResponsiveVisibilityCss(responsiveVisibility, visibilityMap);
}
